import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "configurations/environment";

import { RequestConfig } from "helpers/RequestConfig";

import {
    getLandingPageDetailVisitsAsyncPayload,
    getLandingPageReportsAsyncPayload,
    getLandingPageVisitsAsyncPayload,
} from "./landingReports.types";

export const getLandingPageReportsAsync = createAsyncThunk(
    "landingPageReports/getLandingPageReports",
    async (payload: getLandingPageReportsAsyncPayload) => {
        const response = await axios.get(
            `${baseURL}/api/landing/reports`,
            RequestConfig({
                params: payload,
            }),
        );
        return response.data?.data;
    },
);

export const getLandingPageVisitsAsync = createAsyncThunk(
    "landingPageReports/getLandingPageVisitsAsync",
    async (payload: getLandingPageVisitsAsyncPayload) => {
        const response = await axios.get(
            `${baseURL}/api/landing/pages/visits`,
            RequestConfig({
                params: payload,
            }),
        );
        return response.data?.data;
    },
);

export const getLandingPageDetailVisitsAsync = createAsyncThunk(
    "landingPageReports/getLandingPageDetailVisitsAsync",
    async (payload: getLandingPageDetailVisitsAsyncPayload) => {
        const { id, start_date, end_date } = payload;
        const response = await axios.get(
            `${baseURL}/api/landing/${id}/visits`,
            RequestConfig({ params: { start_date, end_date } }),
        );
        return response.data?.data;
    },
);
